export default __webpack_public_path__ + "static/media/Withdrawal.9f803303.svg";